import { graphql } from 'gatsby'
import tw from 'twin.macro'

export const fragment = graphql`
  fragment Icon on ContentfulComponentIcon {
    __typename
    contentful_id
    title
    unicode
  }
`

export default function IconFont({ unicode, tw: twCss = undefined, css = undefined, ...other }): JSX.Element {
  return unicode ? (
    <span css={[tw`font-bwi text-inherit pointer-events-none`, twCss, css]} {...other}>
      {String.fromCodePoint(parseInt(unicode, 16))}
    </span>
  ) : null
}
